var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block text-nowrap"},_vm._l((_vm.starAmount),function(star,index){return _c('img',{key:index,staticClass:"star",attrs:{"src":star},on:{"click":function($event){return _vm.$emit('input', index + 1)},"mouseenter":function($event){_vm.hover = index + 1},"mouseleave":function($event){_vm.hover = null}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }